const IS_VALID = 'DomainNameValidation_valid';
export const TLD_NOT_SUPPORTED = 'TLD_NOT_SUPPORTED';
export const SHORT_DOMAIN = 'DomainNameValidation_short';
export const LONG_DOMAIN = 'DomainNameValidation_long_dom';
export const NOT_VALID = 'DomainNameValidation_not_valid';

function skipWWW(domainName) {
    let d = domainName.toLowerCase();
    while (d.indexOf('www.') === 0) {
        d = d.substr(4);
    }
    if (d === 'www') {
        d = '';
    }
    return Promise.resolve(d);
}

//make dynamic later on 
export function getTldForPurchase() {
    

    return Promise.resolve([
        "com",
        "net",
        "org",
        "online",
        "store",
        "shop",
        "co.uk",
        "info",
        "com.br",
        "co",
        "biz",
        "club",
        "me",
        "mx",
        "tv",
        "company",
        "rocks",
        "solutions",
        "center",
        "design",
        "today",
        "space",
        "photography",
        "xyz",
        "expert",
        "site",
        "website",
        "agency",
        "guru",
        "email",
        "art",
        "tokyo",
        "photos",
        "pictures",
        "london",
        "land",
        "gifts",
        "top",
        "technology",
        "ninja",
        "party",
        "tips",
        "holiday",
        "wiki",
        "directory",
        "christmas",
        // "fr",
    ])
}


//make dynamic later on 
export function getTldForPurchaseDE() {
    

    return Promise.resolve([
        "com",
        "net",
        "org",
        "online",
        "store",
        "shop",
        "co.uk",
        "info",
        "com.br",
        "co",
        "biz",
        "club",
        "me",
        "mx",
        "tv",
        "company",
        "rocks",
        "solutions",
        "center",
        "design",
        "today",
        "space",
        "photography",
        "xyz",
        "expert",
        "site",
        "website",
        "agency",
        "guru",
        "email",
        "art",
        "tokyo",
        "photos",
        "pictures",
        "london",
        "land",
        "gifts",
        "top",
        "technology",
        "ninja",
        "party",
        "tips",
        "holiday",
        "wiki",
        "directory",
        "christmas",
        // "fr",
        "de"
    ])
}

function removeKnownTld(domainName) {
    return getTldForPurchase()
        .then(tlds => {
            if (tlds.includes(domainName)) {
                return false
            }
            const actualTld = tlds.find(tld => {
                const tldIndex = domainName.indexOf('.' + tld)
                return (tldIndex !== -1 && tldIndex === domainName.length - (tld.length + 1))
            })
            if (actualTld) {
                return domainName.substring(0, domainName.length - (actualTld.length + 1));
            }
        })
}

function removeKnownTld2(domainName) {
    return getTldForPurchaseDE()
        .then(tlds => {
            if (tlds.includes(domainName)) {
                return false
            }
            const actualTld = tlds.find(tld => {
                const tldIndex = domainName.indexOf('.' + tld)
                return (tldIndex !== -1 && tldIndex === domainName.length - (tld.length + 1))
            })
            if (actualTld) {
                return domainName.substring(0, domainName.length - (actualTld.length + 1));
            }
        })
}

export function validateDomain(domainToValidate) {
    const domainAndTldLegalChars = /^([-a-zA-Z0-9\.]+)$/;
    const MAX_DOMAIN_PART_LENGTH = 63;
    const MIN_DOMAIN_PART_LENGTH = 3;

    if (!domainToValidate) {
        return Promise.resolve(NOT_VALID);
    }

    return skipWWW(domainToValidate)
        .then(removeKnownTld)
        .then(domainName => {
            if (!domainName) {
                throw new Error(TLD_NOT_SUPPORTED);
            }
            if (domainName.split('.').some((part) => part.length > MAX_DOMAIN_PART_LENGTH)) {
                throw new Error(LONG_DOMAIN);
            }
            if (domainName.lastIndexOf('-') === (domainName.length - 1) || domainName.indexOf('-') === 0 || domainName.indexOf('xn--') === 0 || domainName.indexOf('..') >= 0) {
                throw new Error(NOT_VALID);
            }

            if (domainAndTldLegalChars.exec(domainName) === null) {
                throw new Error(NOT_VALID);
            }

            let subdomain = null;
            const SUB_DOMAIN_TOO_SHORT = subdomain !== null && subdomain.length < MIN_DOMAIN_PART_LENGTH;
            const DOMAIN_NAME_TO_SHORT = domainName.length < MIN_DOMAIN_PART_LENGTH;
            if (SUB_DOMAIN_TOO_SHORT || DOMAIN_NAME_TO_SHORT) {
                throw new Error(SHORT_DOMAIN);
            }
            return domainName;
        })
}

export function validateDomainDE(domainToValidate) {
    const domainAndTldLegalChars = /^([-a-zA-Z0-9\.]+)$/;
    const MAX_DOMAIN_PART_LENGTH = 63;
    const MIN_DOMAIN_PART_LENGTH = 3;

    if (!domainToValidate) {
        return Promise.resolve(NOT_VALID);
    }

    return skipWWW(domainToValidate)
        .then(removeKnownTld2)
        .then(domainName => {
            if (!domainName) {
                throw new Error(TLD_NOT_SUPPORTED);
            }
            if (domainName.split('.').some((part) => part.length > MAX_DOMAIN_PART_LENGTH)) {
                throw new Error(LONG_DOMAIN);
            }
            if (domainName.lastIndexOf('-') === (domainName.length - 1) || domainName.indexOf('-') === 0 || domainName.indexOf('xn--') === 0 || domainName.indexOf('..') >= 0) {
                throw new Error(NOT_VALID);
            }

            if (domainAndTldLegalChars.exec(domainName) === null) {
                throw new Error(NOT_VALID);
            }

            let subdomain = null;
            const SUB_DOMAIN_TOO_SHORT = subdomain !== null && subdomain.length < MIN_DOMAIN_PART_LENGTH;
            const DOMAIN_NAME_TO_SHORT = domainName.length < MIN_DOMAIN_PART_LENGTH;
            if (SUB_DOMAIN_TOO_SHORT || DOMAIN_NAME_TO_SHORT) {
                throw new Error(SHORT_DOMAIN);
            }
            return domainName;
        })
}

export const prices = {
    "com": 12.95,
    "net": 12.95,
    "org": 12.95,
    "online": 34.00,
    "store": 34.00,
    "shop": 43.95,
    "co.uk": 12.95,
    "info": 12.95,
    "com.br": 18.50,
    "co": 28.95,
    "biz": 13.95,
    "club": 12.95,
    "me": 15.95,
    "mx": 43.95,
    "tv": 30.95,
    "company": 20.95,
    "rocks": 13.95,
    "solutions": 20.95,
    "center": 20.95,
    "design": 43.95,
    "today": 20.95,
    "space": 12.95,
    "photography": 20.95,
    "xyz": 13.95,
    "expert": 43.95,
    "site": 28.95,
    "website": 22.00,
    "agency": 20.95,
    "guru": 28.95,
    "email": 20.95,
    "art": 13.95,
    "tokyo": 20.95,
    "photos": 20.95,
    "pictures": 12.95,
    "london": 43.95,
    "land": 28.95,
    "gifts": 20.95,
    "top": 20.95,
    "technology": 20.95,
    "ninja": 20.95,
    "party": 28.95,
    "tips": 20.95,
    "holiday": 43.95,
    "wiki": 28.95,
    "directory": 20.95,
    "christmas": 28.95,
    "fr": 19.95,
	"de": '14,95'
}